<template>
  <div>
    <div class="centered loader is-large" v-if="loading"></div>
    <section
      v-else
      aria-labelledby="notes-title"
    >
      <div
        v-if="isNotEmpty"
        class="bg-white shadow sm:rounded-lg sm:overflow-hidden"
      >
        <div class="px-4 sm:px-6">
          <ul class="divide-y divide-gray-100">
            <li
                v-for="note in notes"
                :key="note.id"
                :id="'note-'+note.id"
                aria-labelledby="notes-title"
                class="py-6"
            >
              <div class="flex items-start space-x-3">
                <div class="flex-shrink-0">
                  <img
                      :src="note.created_user.extra_small_avatar"
                      class="w-10 h-10 rounded-full">
                </div>
                <div class="w-full">
                  <div class="mb-1 text-sm font-medium text-gray-900">{{ note.created_user.name }}</div>
                  <div
                    v-html="note.note"
                    class="mb-2 text-sm text-gray-700"
                  ></div>
                  <div class="flex justify-between space-x-2 text-xs font-medium">
                    <span class="text-gray-500">{{ moment(note.created_at).format('LLLL') }}</span>
                    <span
                      v-if="note.project_id"
                      class="text-gray-600"
                    >
                      Project: <a :href="route('projects.show', {project: note.project_id})" class="tw-link">{{ note.project.name }}</a>
                    </span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div
        v-else
        class="p-3 rounded-md bg-blue-50"
      >
        <div class="flex-1 ml-3 md:flex md:justify-between">
          <p class="text-sm text-gray-800">{{ trans('app.note.none') }}</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

export default {
    props: {
        type: {
            type: String,
            required: true,
        },
        typeId: {
            type: Number,
            required: true,
        },
    },

    data () {
        return {
            loading: true,
            notes: [],
        };
    },

    computed: {
        isNotEmpty () {
            return ! _.isEmpty(this.notes);
        },
    },

    listeners: {
        async 'notes-updated' () {
            await this.fetchList();
        },
    },

    methods: {
        async fetchList () {
            try {
                this.loading = true;

                let {data} = await axios.get(
                    this.route('notes.index',
                        {
                            type: this.type,
                            type_id: this.typeId,
                        }
                    ));

                this.notes = data.data;

                OSPEvent.$emit('notes-fetched', {type: this.type});
            } catch (errors) {
                console.error(errors);
            } finally {
                this.loading = false;
            }
        },
    },

    async created () {
        await this.fetchList();
    },
};
</script>
